import type { LeaderboardActivityType } from '../models/public-leaderboard.model';

/**
 * Progress bar fill (0–100): participant XP as a share of rank-1 XP (100%).
 * Rank 1 always maps to 100%; lower ranks are proportional (xp / leaderXp).
 */
export function computeLeaderboardProgressPercent(participantXp: number, leaderXp: number): number {
  if (leaderXp <= 0 || !Number.isFinite(participantXp) || !Number.isFinite(leaderXp)) {
    return 0;
  }
  return Math.min(100, Math.round((participantXp / leaderXp) * 100));
}

/**
 * Threshold boards: progress toward the win XP (100% when xp >= threshold).
 */
export function computeLeaderboardProgressTowardThreshold(
  participantXp: number,
  xpWinThreshold: number,
): number {
  if (xpWinThreshold <= 0 || !Number.isFinite(participantXp) || !Number.isFinite(xpWinThreshold)) {
    return 0;
  }
  return Math.min(100, Math.round((participantXp / xpWinThreshold) * 100));
}

export interface LeaderboardProgressContext {
  activityType: LeaderboardActivityType;
  leaderXp: number;
  xpWinThreshold?: number;
}

export function computeLeaderboardRowProgress(
  participantXp: number,
  ctx: LeaderboardProgressContext,
): number {
  if (ctx.activityType === 'threshold' && (ctx.xpWinThreshold ?? 0) > 0) {
    return computeLeaderboardProgressTowardThreshold(participantXp, ctx.xpWinThreshold!);
  }
  return computeLeaderboardProgressPercent(participantXp, ctx.leaderXp);
}
